<div class="loading-interno animate__animated animate__fadeIn animate__faster">
  <img src="../../assets/iconografia/carga-simpli.gif" alt="Cargando..." style="height: 100px;">

  <mat-label class="main-message">{{ currentMessage }}</mat-label>
  <mat-label class="sub-message">{{ subMessage }}</mat-label>

  <div class="progress-bar-container">
    <div class="progress-bar" [style.width.%]="progress"></div>
  </div>

  @if (estimatedTimeRemaining) {
    <mat-label class="estimated-time">{{ estimatedTimeRemaining }}</mat-label>
  }

</div>